// Authentication configuration matching sogni-photobooth/dashboard pattern

export const getAuthConfig = () => {
  const hostname = window.location.hostname;

  const isLocalDev = hostname === 'localhost' || hostname === '127.0.0.1';
  const isStaging = hostname.includes('staging');

  let appUrl;
  if (isLocalDev) {
    appUrl = 'https://app-local.sogni.ai';
  } else if (isStaging) {
    appUrl = 'https://app-staging.sogni.ai';
  } else {
    appUrl = 'https://app.sogni.ai';
  }

  return {
    appUrl,
    authUrl: `${appUrl}/authenticate/`,
    signupUrl: `${appUrl}/signup/`
  };
};

export const redirectToAuth = (mode = 'login') => {
  const config = getAuthConfig();
  const currentUrl = window.location.href;

  const url = new URL(mode === 'signup' ? config.signupUrl : config.authUrl);
  url.searchParams.set('redirect', currentUrl);
  url.searchParams.set('authMode', 'cookies');
  window.location.href = url.toString();
};

export default {
  getAuthConfig,
  redirectToAuth
};


